import styled from 'styled-components';

export const Container = styled.div`
    position: relative;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    text-align: right;
`;

export const Content = styled.button`    
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 5px;
    color: #707070;
    background-color: ${props => props.color ? props.color : 'white'};
    cursor: pointer;
    height: 50px;
    width: 50px;
`;

export const Spinner = styled.div`
    margin: ${props => props.margin ? props.margin : '15px'};
    .loader {
        border: 3px solid #f3f3f3; /* Light grey */
        border-top: 3px solid #3498db; /* Blue */
        border-radius: 50%;
        width: 20px;
        height: 20px;
        animation: spin 2s linear infinite;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

`;